import { Skeleton, Stack } from "@mui/material";

/** Skeleton loading for the settings integration */
export function IntegrationSettingsSkeleton(): JSX.Element {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      paddingX="1.25rem"
      justifyContent="space-between"
      width="100%"
      gap="1rem"
      marginY="1.75rem"
    >
      <Stack
        flexDirection="row"
        gap="1.875rem"
        alignItems="center"
        width="100%"
      >
        <Skeleton
          variant="rectangular"
          sx={{ width: "2.5rem", height: "2.5rem" }}
        />
        <Stack width="100%">
          <Skeleton variant="text" width="20%" />
          <Skeleton variant="text" width="50%" />
        </Stack>
      </Stack>

      <Skeleton variant="rectangular" sx={{ width: "10%", height: "1.25rem" }} />
    </Stack>
  );
}
